import { ScrollToApplyButton } from '#/components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from '#/components/Breakpoint/DesktopOnly';
import { SaveListingButton } from '#/components/SaveButton/SaveListingButton';
import { ShareListingButton } from '#/components/ShareListingButton/ShareListingButton';
import { ListingActionsDropdown } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from '#/modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { ApiInternship } from '#/modules/listing/internships/api/types/ApiInternship';
import type { OrgDashboardApiInternship } from '#/modules/orgDashboard/api/listing/types/OrgDashboardApiInternship';

type Props = {
  internship: ApiInternship | OrgDashboardApiInternship;
  applied: boolean;

  // Save internship
  internshipSaved: boolean;
  onSaveInternship: () => Promise<void>;
  onUnsaveInternship: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewInternshipActionButtons({
  internship,
  applied,
  internshipSaved,
  onSaveInternship,
  onUnsaveInternship,
  orgSaved,
  shouldShowSaveOrgTooltip,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  return (
    <ListingViewActionButtons>
      <ScrollToApplyButton applied={internship.hasAts && applied} />

      <SaveListingButton
        listingType="INTERNSHIP"
        listingSaved={internshipSaved}
        onSaveListing={onSaveInternship}
        onUnsaveListing={onUnsaveInternship}
        orgDetails={{
          onSaveOrg,
          onDismissSaveOrgTooltip,
          shouldShowSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!internship.url}
          listingId={internship.id}
          listingType="INTERNSHIP"
          listingUrl={internship.url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={internship.id}
        listingType="INTERNSHIP"
        listingUrl={internship.url}
        orgDetails={
          internship.org
            ? {
                orgId: internship.org.id,
                orgName: internship.org.name,
                orgType: internship.org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        markAsAppliedButton={null}
      />
    </ListingViewActionButtons>
  );
}
